import { module as Module } from 'modujs'
import { gsap } from 'gsap'
import { MorphSVGPlugin } from 'gsap/MorphSVGPlugin'
import { body } from '../utils/environment'

gsap.registerPlugin(MorphSVGPlugin)

export default class extends Module {
  constructor(m) {
    super(m)

    this.heroIcon = document.querySelector('.c-header_logo svg #initialIcon')

    this.events = {
      mouseenter: 'mouseEnter',
      click: 'onClick',
    }

    this.timeline = gsap.timeline({ paused: true })
      .to(this.heroIcon, {
        morphSVG: { shape: '#baseIcon' },
      })
      .to(this.heroIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence1' },
      }, '-=0.4')
      .to(this.heroIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence2' },
      })
      .to('.c-header_logo svg', {
        attr: {
          viewBox: '0 0 40 20',
        },
        duration: 0.4,
        ease: 'power2.inOut',
      })
      .to(this.heroIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence3' },
      }, '-=0.4')
      .to('.c-header_logo svg', {
        attr: {
          viewBox: '0 0 53 20',
        },
        duration: 0.4,
        ease: 'power2.inOut',
      })
      .to(this.heroIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence4' },
      }, '-=0.4')
      .to(this.heroIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#baseIcon' },
      })
  }

  init() {
    this.productionPage()
    this.servicesPage()
  }

  onClick() {
    if (!body.classList.contains('home')) {
      window.history.back()
    }
  }

  mouseEnter() {
    this.timeline.restart()
  }

  productionPage() {
    if (body.classList.contains('page-template-template-production')) {
      gsap.to(this.heroIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence3' },
      })
    }
  }

  servicesPage() {
    if (body.classList.contains('page-template-template-services')) {
      gsap.to(this.heroIcon, {
        duration: 0.4,
        ease: 'power2.inOut',
        morphSVG: { shape: '#sequence1' },
      })
    }
  }

  update() {
    gsap.to(this.heroIcon, {
      duration: 0.4,
      ease: 'power2.inOut',
      morphSVG: { shape: '#baseIcon' },
    })

    this.productionPage()
    this.servicesPage()
  }

  destroy() {
    gsap.to(this.heroIcon, {
      duration: 0.4,
      ease: 'power2.inOut',
      morphSVG: { shape: '#baseIcon' },
    })
  }
}
